import * as React from 'react';

function SvgNavArrow(props) {
  return (
    <svg viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.71 12.158a.75.75 0 11-.92 1.184L.29 7.503a.75.75 0 01-.016-1.171L7.774.17a.75.75 0 01.952 1.16L1.951 6.895l6.76 5.263z" />
    </svg>
  );
}

export default SvgNavArrow;
